import { ReferralProgramStatusEnum } from "../models/types.mjs";
import { SubscriptionStatus } from "../models/subscription.mjs";
import { DateTime } from "luxon";

// src/paymentMethod/subscriptionStatus.ts
const ACTIVE_STATUSES = /* @__PURE__ */ new Set([
	"active",
	"past_due",
	"trialing"
]);
const EXPIRED_STATUSES = /* @__PURE__ */ new Set([
	"expired",
	"canceled",
	"incomplete_expired"
]);
/**
* Maps Stripe subscription status or internal SubscriptionStatus to the
* three-value access model used by payment method builders.
*/
function normalizeSubscriptionStatus(status) {
	if (status == null) return "inactive";
	const normalized = status.toLowerCase();
	if (ACTIVE_STATUSES.has(normalized)) return "active";
	if (EXPIRED_STATUSES.has(normalized)) return "expired";
	return "inactive";
}
/** Sponsored access only when status is `active` and the end date has not passed. */
function getSubscriptionStatusFromSponsorInfo(sponsorInfo, signupFlowCompleted, now) {
	if (!sponsorInfo || !signupFlowCompleted) return "inactive";
	if (sponsorInfo.status !== "active") return sponsorInfo.status === "expired" ? "expired" : "inactive";
	if (!sponsorInfo.endDate || DateTime.fromJSDate(sponsorInfo.endDate, { zone: now.zone }).startOf("day").diff(now.startOf("day"), "days").days >= 0) return "active";
	return "expired";
}

export { getSubscriptionStatusFromSponsorInfo, normalizeSubscriptionStatus };
//# sourceMappingURL=subscriptionStatus.mjs.map